import { render, staticRenderFns } from "./person-compare-mobile.vue?vue&type=template&id=70a7ac4d&scoped=true&lang=pug&"
import script from "./person-compare-mobile.vue?vue&type=script&lang=js&"
export * from "./person-compare-mobile.vue?vue&type=script&lang=js&"
import style0 from "./person-compare-mobile.scss?vue&type=style&index=0&id=70a7ac4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7ac4d",
  null
  
)

export default component.exports